<ng-container *ngIf="viewModel() as viewModel">
    <bs-digital-system-bet-bar></bs-digital-system-bet-bar>
    <bs-digital-pick-list>
        <bs-digital-system-bet-pick
            *ngFor="let pick of viewModel.pickList; trackBy: pickTrackBy"
            [pick]="pick"
            [systemBetPick]="systemBetPick(viewModel.systemBetState, pick)"
            [systemBetState]="viewModel.systemBetState"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [removeButtonPosition]="removeButtonPosition"
            [removeButtonStyle]="removeButtonStyle"
            [isSelectionCheckboxVisible]="true"
            [msAutomation]="pick.id.toString()">
        </bs-digital-system-bet-pick>
    </bs-digital-pick-list>
    <bs-digital-picks-toolbar [picks]="viewModel.systemBetState.picks"></bs-digital-picks-toolbar>
</ng-container>
